export const MEMORY_STEP_COPY = {
  heading: 'Every minute of your day, captured. Zero effort.',
  subheading:
    "The Memory app remembers everything you work on so you don't have to. Your timesheet fills itself.",
  ctaLabel: 'Install Memory',
  ctaLabelInstalling: 'Installing Memory',
  ctaLabelInstalled: 'Memory was installed!',
  installStepOpenZip: 'Open the downloaded zip file',
  installStepRunInstaller: 'Run the installer (Memory)',
  installStepPermissionsMac: 'Click "Allow" when asked for permissions',
  installStepPermissionsWindows: 'Click "Yes" when asked to allow changes',
  installStepPermissionsDefault: 'Allow the permissions when prompted',
  installStepReturn: 'Return to this page',
  trustPoints: [
    '100% private to you',
    'Captures time in apps & websites',
    'Pause any time',
  ] as const,
  trustText: 'Trusted by 5,000+ businesses worldwide',
  remindMeLater: 'Remind me later',
  continueWithoutInstalling: 'Continue without installing',
  continueAfterInstalling: 'Continue',
} as const;

export const CALENDAR_STEP_COPY = {
  heading: 'Your meetings, already on your Timeline.',
  subheading:
    'Connect your calendar and every meeting appears automatically — named, timed, and dropped straight into your timesheet.',
  googleCalendarLabel: 'Connect Google Calendar',
  office365Label: 'Connect Office 365',
  calendarSublabel: 'Takes seconds',
  remindMeLater: 'Remind me later',
  remindMeLaterWarning:
    "Your Timeline will only show app activity — meetings won't appear until you connect. We'll remind you when you're in the app.",
  continueWithoutCalendar: 'Continue without calendar',
  continueAfterCalendar: 'Calendar connected! Continue →',
} as const;
